import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DeleteNotice } from "../types/types";
import { putReadingCheck } from "../api/notice";

export const usePutReadingCheck = ({ idx }: DeleteNotice) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => putReadingCheck({ idx }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["notice"],
      });
      queryClient.invalidateQueries({
        queryKey: ["noticeDetail"],
      });
    },
  });
  return mutation;
};
